(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const menuLists = document.querySelectorAll('[data-menu-id]');
    const headerVariants = document.querySelectorAll('[data-header-brand-link]');

    const DEFAULT_BRAND_ID = document.body?.dataset?.defaultBrand?.trim() || 'sabo';
    const PAGE_BRAND = document.body?.dataset?.pageBrand?.trim();

    const getAvailableBrandIds = () => {
      const ids = new Set();
      menuLists.forEach(node => {
        const id = node.dataset.menuId?.trim();
        if (id) ids.add(id);
      });
      headerVariants.forEach(node => {
        const id = node.dataset.sourceMenuId?.trim();
        if (id) ids.add(id);
      });
      return ids;
    };

    const applyA11yState = (activeId) => {
      headerVariants.forEach(header => {
        const isActive = header.dataset.sourceMenuId?.trim() === activeId;
        header.classList.toggle('active', !!isActive);
        header.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        header.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (!header.hasAttribute('role')) header.setAttribute('role', 'tab');
        if (!header.hasAttribute('tabindex')) header.setAttribute('tabindex', '0');
      });
      try {
        document.body.dataset.activeBrand = activeId;
        const announcers = document.querySelectorAll('[data-brand-announcer]');
        announcers.forEach(a => a.textContent = `Brand set to ${activeId}`);
      } catch { }
    };

    const pickDefaultBrand = (availableIds) => {
      if (availableIds.has(DEFAULT_BRAND_ID)) return DEFAULT_BRAND_ID;
      // fallback: first available id from menus or variants
      const first = [...availableIds][0];
      return first ?? DEFAULT_BRAND_ID;
    };

    const initFromUrl = (availableIds) => {
      try {
        const url = new URL(window.location.href);
        const urlBrand = url.searchParams.get('brand')?.trim();
        if (urlBrand && availableIds.has(urlBrand)) {
          localStorage.setItem('headerMenuId', urlBrand);
          // Clean the URL param but preserve other params
          url.searchParams.delete('brand');
          history.replaceState({}, '', url.toString());
        }
      } catch (_) {
        /* noop */
      }
    };

    const updateHeaderLogoAndMenuVariant = () => {
      if (!menuLists) return;

      let headerMenuId = localStorage.getItem('headerMenuId')?.trim();
      const availableIds = getAvailableBrandIds();

      // If stored id is missing/invalid, choose default
      if (!headerMenuId || !availableIds.has(headerMenuId)) {
        headerMenuId = pickDefaultBrand(availableIds);
        localStorage.setItem('headerMenuId', headerMenuId);
      }

      applyA11yState(headerMenuId);

      menuLists.forEach(menuList => {
        menuList.classList.toggle('hidden', menuList.dataset.menuId?.trim() !== headerMenuId);
      });
    };

    // Initialize from URL param first (e.g., ?brand=zaco)
    initFromUrl(getAvailableBrandIds());

    // If page is brand-locked, force the brand and persist it
    if (PAGE_BRAND) {
      try {
        localStorage.setItem('headerMenuId', PAGE_BRAND);
      } catch {}
    }
    updateHeaderLogoAndMenuVariant();

    document.addEventListener('click', (event) => {
      const header = event.target.closest('[data-header-brand-link]');
      if (!header) return;
      const { sourceMenuId } = header.dataset;
      const headerMenuId = sourceMenuId?.trim();

      if (headerMenuId) {
        try { localStorage.setItem('headerMenuId', headerMenuId); } catch {}

        // On brand-locked pages, navigate to the destination brand's homepage
        if (PAGE_BRAND && headerMenuId !== PAGE_BRAND) {
          try {
            const url = new URL('/', window.location.origin);
            url.searchParams.set('brand', headerMenuId);
            window.location.assign(url.toString());
            return;
          } catch {}
        }

        // Neutral pages: switch in place
        updateHeaderLogoAndMenuVariant();
      }
    });

    // Keyboard support for triggers
    document.addEventListener('keydown', (event) => {
      const header = event.target.closest?.('[data-header-brand-link]');
      if (!header) return;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        header.click();
      }
    });

    document.addEventListener('cart:update', () => setTimeout(updateHeaderLogoAndMenuVariant, 100));
  });
})();
